import React from "react";

export default function ContentQuestionReactions({
    item,
    onToggle,
    disabled,
}) {
    return (
        <div className="cq-reactions">
            <button
                type="button"
                className={`cq-reaction ${item?.likedByCurrentUser ? "is-active" : ""}`}
                onClick={() => onToggle?.("LIKE")}
                disabled={disabled}
            >
                Like <span>{item?.likeCount || 0}</span>
            </button>
            <button
                type="button"
                className={`cq-reaction ${item?.helpfulByCurrentUser ? "is-active" : ""}`}
                onClick={() => onToggle?.("HELPFUL")}
                disabled={disabled}
            >
                Helpful <span>{item?.helpfulCount || 0}</span>
            </button>
        </div>
    );
}
